import router from "@/router";

const urlHandler = {
    /**
     * Check if url is the same as sent 'route'
     * @param {String} route 
     * @returns {Bool}
     */
    checkUrl(route = ''){
        return window.location.pathname == route;
    },

    /**
     * Redirects to sent url
     * @param {String} url 
     * @param {Object} params
     */
    async redirect(url = '/', params = {}) {
        await new Promise(resolve => setTimeout(resolve, 0));
        await router.push({path: url, query: params});
    },

    /**
     * Gets current route or check
     */
    currentRoute() {
        return window.location;
    },

    /**
     * Checks if current route contains
     * @param {string} search
     * @returns {bool}
     */
    currentRouteContains(search) {
        return this.currentRoute().pathname.search(search) != -1;
    },

    /**
     * Opens link
     * @param {string} url 
     * @param {bool} newPage
     */
    openExternal(url = '', newPage = true) {
        const target = newPage ? '_blank' : '';

        window.open(url, target);
    },

    /**
     * Reloads the page
     */
    reloadPage() {
        window.location.reload();
    },

    /**
     * Opens link as a new page on this website
     * @param {string} url
     */
    redirectBlank(url = '') {
        const parsedUrl = `${window.location.origin}${url}`;

        this.openExternal(parsedUrl, true);
    },

    /**
     * Redirects to url and go to ID or page top
     * @param {String} url
     * @param {Object} params
     * @param {String} target - id to scroll to or scrolls to page top
     */
    async redirectAndScroll(url = '', params = {}, target = null) {
        await this.redirect(url, params);

        if (!target) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            return;
        }

        const element = document.querySelector(target);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        } else {
            console.warn(`Element: "${target}" not fond to scroll.`);
        }
    }
}

export default urlHandler;